import { useUpdateUserSettings } from 'features/user';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { useKeysDown } from 'shared/hooks/use-keys-down';
import { usePremiumFeatureAllowed } from 'shared/hooks/use-premium-feature-allowed';
import { useUser } from 'shared/hooks/use-user';
import { GoalOverviewRoadmapViewOptions } from 'shared/types/goal-overview';
import { LimitKeys } from 'shared/types/limit-keys';
import { targetIsInput } from 'shared/utils/target-is-input';
import { useTheme } from 'styled-components';

export const useSelectedView = () => {
  const theme = useTheme();
  const user = useUser();

  const openPremiumDialog = useOpenPremiumDialog();
  const updateUserSettings = useUpdateUserSettings();

  const { allowed: isGoalTimelineAllowed } = usePremiumFeatureAllowed(
    LimitKeys.DesktopGoalsOverviewTimeline,
    {},
  );

  const view =
    (isGoalTimelineAllowed && !theme.isMobile
      ? user?.settings?.goalsOverview?.webView
      : undefined) ?? GoalOverviewRoadmapViewOptions.List;

  const setView = (view: GoalOverviewRoadmapViewOptions) => {
    if (
      view === GoalOverviewRoadmapViewOptions.Timeline &&
      !isGoalTimelineAllowed
    ) {
      openPremiumDialog();
      return;
    }

    updateUserSettings({ goalsOverview: { webView: view } });
  };

  useKeysDown(['KeyL'], (e) => {
    if (targetIsInput(e.target)) {
      return; // Don't open dialog
    }
    setView(GoalOverviewRoadmapViewOptions.List);
  });

  useKeysDown(['KeyT'], (e) => {
    if (targetIsInput(e.target)) {
      return; // Don't open dialog
    }
    setView(GoalOverviewRoadmapViewOptions.Timeline);
  });

  return {
    view,
    setView,
  };
};
